// B9: when a grown-up changes a child's controls, the child's phone says so once ("Dad changed
// your rules: Most plays a day: 3"), so the rules never change behind their back.
import { useEffect } from 'react'
import { ChildSettingsSet } from '../../shared/controls'
import type { Person } from '../../shared/events'
import { kvGet, kvSet } from '../data/db'
import { useEvents } from '../data/progress'
import { useSession } from '../data/session'
import { describeRules } from '../domain/controls'
import { t } from '../strings/en'
import { useToast } from './toast'

export function useRulesChangedNote(person: Person) {
  const events = useEvents()
  const people = useSession((s) => s.people)
  const latest = person.kind === 'child' ? events.filter((e) => e.type === 'child.settings.set' && (e.payload as { childId?: string }).childId === person.id).sort((a, b) => (a.seq ?? Infinity) - (b.seq ?? Infinity) || a.at - b.at).at(-1) : undefined
  const id = latest?.id
  useEffect(() => {
    if (!latest || !id) return
    const key = `rulesSeen:${person.id}`
    void kvGet<string>(key).then((seen) => {
      if (seen === id) return
      void kvSet(key, id)
      const p = ChildSettingsSet.safeParse(latest.payload)
      const what = p.success ? describeRules(p.data.fields).join(' · ') : ''
      if (!what) return
      const who = people?.find((x) => x.id === latest.personId)?.name ?? t.plays.grownUp
      useToast.getState().show(t.rules.changed(who, what), 5000)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps -- once per new settings event
  }, [id, person.id])
}
